module.exports = __webpack_public_path__ + "seychelles.svg?efe0b090050a5354769cb5d316110698";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/seychelles.svg
// module id = 289
// module chunks = 10